import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as appList from './app-list'
import * as footer from './footer'
import * as logo from './logo'
import { Store } from './store'

@ngCore.Component({
  imports: [
    logo.Component,
    appList.Component,
    footer.Component,
    ds.layout.divider.Component,
    ds.splashScreen.Component,
  ],
  selector: 'atn-navbar',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.OnDestroy {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /**
   * Refers to the root navbar element
   *
   * Used to determine the width of the element
   */
  private readonly _navbarElRefSg =
    ngCore.viewChild<ngCore.ElementRef<HTMLElement>>('navbarEl')

  /**
   * Observing navbar resize
   */
  private readonly _resizeObserver = new ResizeObserver(() => {
    const navbarEl = this._navbarElRefSg()?.nativeElement
    if (navbarEl) {
      const { width } = navbarEl.getBoundingClientRect()
      this.store.updateWidth(width)
    }
  })

  constructor() {
    /**
     * Observe navbarEl for resize as soon as it gets created
     */
    ngCore.effect(() => {
      const navbarEl = this._navbarElRefSg()?.nativeElement
      if (navbarEl) {
        this._resizeObserver.observe(navbarEl)
      }
    })
  }

  /**
   * Disconnecting observer upon destroying the component
   */
  ngOnDestroy(): void {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
    }
  }
}
